export default "__VITE_ASSET__C3DfcH7P__"